import { styled } from '@mui/material';
import { LoadingButton, LoadingButtonProps } from '@mui/lab/';

export const LoadingButtonStyled = styled(LoadingButton)<LoadingButtonProps>(() => ({
  borderRadius: '6.3662px',
  boxShadow: 'none',
  fontSize: '16px',
  fontWeight: '600',
  padding: '10px 0',
}));
